export default __webpack_public_path__ + "static/slider-pp-1a641f5d22f765818a067b8c8ce9f40d.avif";